// extracted by mini-css-extract-plugin
export var calendarView = "_mt-0";